import AnionTestingPart from './AnionTestingPart';

export default function Part7Carbonate() {
  return (
    <AnionTestingPart
      partNumber={7}
      anionSymbol="CO32-"
      anionName="Carbonate"
      anionFormula="0.1 M Na₂CO₃"
      anionColor="#F5F5F5"
      infoContent={{
        title: 'Carbonate Solubility',
        content: 'Most carbonates are insoluble except Group 1 (Na+, K+) and NH4+. You should see multiple white precipitates. Some reactions may also produce gas bubbles if the solution is acidic.'
      }}
    />
  );
}
